import { useMutation } from "@apollo/client";
import { useCallback } from "react";
import { graphql } from "../gql";
import { UserGroupAvailabilityInput } from "./useCreateUserGroup.ts";

const UpdateUserGroupMutation = graphql(`
  mutation updateUserGroup(
    $id: String!
    $availability: [UserGroupAvailabilityInput!]
    $onboardingLiveRequired: Boolean
    $onboardingLiveBookingWindowDays: Int
  ) {
    updateUserGroup(
      id: $id
      availability: $availability
      onboardingLiveRequired: $onboardingLiveRequired
      onboardingLiveBookingWindowDays: $onboardingLiveBookingWindowDays
    ) {
      id
      onboardingLiveRequired
      onboardingLiveBookingWindowDays
    }
  }
`);

export function useUpdateUserGroup() {
  const [mutate, { loading }] = useMutation(UpdateUserGroupMutation, {
    refetchQueries: ["getAllUserGroups"],
  });
  const updateUserGroup = useCallback(
    async (input: {
      id: string;
      availability: UserGroupAvailabilityInput[];
      onboardingLiveRequired: boolean;
      onboardingLiveBookingWindowDays: number;
    }) => {
      await mutate({
        variables: {
          id: input.id,
          availability: input.availability.map((a) => ({
            ...a,
            timeIntervalTimezone: a.timeIntervalTimezone ?? "Europe/Rome",
          })),
          onboardingLiveRequired: input.onboardingLiveRequired,
          onboardingLiveBookingWindowDays:
            input.onboardingLiveBookingWindowDays,
        },
      });
    },
    [mutate],
  );
  return { updateUserGroup, loading };
}
